export default __webpack_public_path__ + "static/media/desktop_banner_payment.ea243500.jpg";